@if (shouldShow()) {
  <div @fadeSlide class="text-red-600 text-sm mt-1 space-y-1">
    @for (msg of messages(); track msg) {
      <p class="m-0">{{ msg.textOverride || (msg.key | translate : msg.params) }}</p>
    }
  </div>
}


